module.exports = __webpack_public_path__ + "2ba36f96c4b87aebe1f7bf6bb8dfe1db.pdf";